<template>
 <div>
  <v-dialog :value="show" max-width="680" scrollable content-class="student-situation-window" aria-labelledby="situation-list-title" @input="value => { if (!value) cancel() }">
   <v-card class="ss-card ss-history">
    <div class="ss-header"><div><h2 id="situation-list-title">学习状况记录</h2><p>回顾老师记录的学习进展</p></div><v-btn icon aria-label="关闭学习状况记录" @click="cancel"><v-icon>mdi-close</v-icon></v-btn></div>
    <v-card-text class="ss-body">
     <div v-if="loading" class="ss-empty" role="status"><v-progress-circular indeterminate size="26" width="2" color="#d9363e"/><p>正在加载学习记录…</p></div>
     <v-alert v-else-if="error" outlined dense type="error" role="alert">{{error}}<v-btn text small @click="getStudentSituationList">重试</v-btn></v-alert>
     <div v-else-if="!items.length" class="ss-empty"><v-icon size="38">mdi-notebook-outline</v-icon><h3>暂无学习状况记录</h3><p>填写后，可在这里查看老师记录的学习进展。</p></div>
     <div v-else class="ss-timeline"><article v-for="item in items" :key="item.id" class="ss-record"><div class="ss-record-meta"><time>{{item.createAt}}</time><span>{{item.className || '未命名班级'}}</span></div><p>{{item.briefDesc}}</p><div class="ss-record-author"><v-icon size="15">mdi-account-edit-outline</v-icon>{{item.creatorName || '老师'}}</div></article></div>
    </v-card-text>
    <v-card-actions class="ss-footer"><v-btn outlined @click="cancel">关闭</v-btn></v-card-actions>
   </v-card>
  </v-dialog>
 </div>
</template>

<script>
export default {
 name: 'student-situation-list',
 props: { show: { type: Boolean, default: false }, studentId: { type: String, default: '' } },
 data() { return { items: [], loading: false, error: '', requestId: 0 } },
 watch: {
  show(value) { if (value) this.getStudentSituationList(); else this.requestId++ },
  studentId() { this.items = []; this.requestId++; if (this.show) this.getStudentSituationList() }
 },
 beforeDestroy() { this.requestId++ },
 methods: {
  cancel() { this.$emit('cancel', '') },
  async getStudentSituationList() {
   const requestId = ++this.requestId, studentId = this.studentId
   this.items = []; this.loading = true; this.error = ''
   try {
    const response = await this.axios.get(`/edu/student/situation/list/${studentId}`)
    if (requestId!==this.requestId || studentId!==this.studentId) return
    if (!response.data || response.data.code!==200) throw new Error((response.data && response.data.message) || '加载失败，请重试')
    this.items = Array.isArray(response.data.data) ? response.data.data : []
   } catch (error) {
    if (requestId===this.requestId && studentId===this.studentId) this.error = (error && error.message) || '加载失败，请稍后重试'
   } finally { if (requestId===this.requestId && studentId===this.studentId) this.loading = false }
  }
 }
}
</script>

<style scoped lang="scss" src="../assets/styles/student-situation.scss"></style>
